import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./EventsSlider.scss";
const EventsSlider = ({ events }) => {
    const [swiperInstance, setSwiperInstance] = useState(null);
    useEffect(() => {
        if (swiperInstance) {
            swiperInstance.slideTo(0, 0);
        }
    }, [events, swiperInstance]);
    return (_jsxs("div", { className: "outer-container", children: [_jsx(Swiper, { className: "events-slider", onSwiper: setSwiperInstance, spaceBetween: 80, slidesPerView: "auto", allowTouchMove: true, grabCursor: true, modules: [Navigation, Pagination], navigation: {
                    nextEl: "#swiper-button-next",
                    prevEl: "#swiper-button-prev",
                }, pagination: {
                    el: ".events-slider__pagination",
                    clickable: true,
                }, breakpoints: {
                    1024: { slidesPerView: 3, spaceBetween: 80 },
                    320: { slidesPerView: 1.6, spaceBetween: 10 },
                }, children: events.map((event, index) => (_jsx(SwiperSlide, { className: "events-slider__slide", children: _jsxs("div", { className: "events-slider__event", children: [_jsx("div", { className: "events-slider__event__year", children: event.year }), _jsx("div", { className: "events-slider__event__title", children: event.title })] }) }, `${event.year}-${index}`))) }), _jsx("div", { className: "events-slider__pagination" }), _jsx("button", { id: "swiper-button-next", children: _jsx("svg", { viewBox: "0 0 8 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M0.707093 0.707092L5.70709 5.70709L0.707093 10.7071", stroke: "#3877EE", strokeWidth: "2" }) }) }), _jsx("button", { id: "swiper-button-prev", children: _jsx("svg", { viewBox: "0 0 8 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M0.707093 0.707092L5.70709 5.70709L0.707093 10.7071", stroke: "#3877EE", strokeWidth: "2" }) }) })] }));
};
export default EventsSlider;
